// Define your function to handle the click on a.t4s-pr-quickview
// $(".t4s-product-wrapper .t4s-pr-quickview, a.t4s-pr-item-btn.t4s-pr-addtocart").click(function() {
//     // Set a timeout to click on $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item") after 800 milliseconds
//     setTimeout(function() {
//         $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item.is--selected").click();
//     }, 900);
// });

// Listen for the modal to become active
// $(document).on('DOMNodeInserted', function(e) {
//     // Check if the inserted node is the modal and has the class 't4s-modal--is-active'
//     if ($(e.target).hasClass('t4s-modal') && $(e.target).hasClass('t4s-modal--is-active')) {
//         // Click the desired element inside the modal
//         $(".t4s-swatch__option.is-t4s-name__item .t4s-swatch__item.is--selected").click();
//     }
// });


// jQuery_T4NT(document).ready(function($) {
// $(document).on("variant:changed", function(evt) {
//     var price = evt.currentVariant.price;
//     var parentContainer = $(".t4s-product__info-container");
//     // alert(price);
//     // console.log('ghi', parentContainer)
//     var priceRequestLink = `<span><a href="https://api.whatsapp.com/send?phone=923006225159&text=Hello i am interested in {{shop.domain}}{{ product.url }}" class="t4s-pr-item-btn t4s-pr-addtocart callforpricing" rel="nofollow" target="_blank"><span class="t4s-text-pr">Price on Request</span></a></span>`;

//     if (parseFloat(price) == 0) {
//         console.log("zero hai")
//         parentContainer.find(".t4s-product-form__buttons").hide();
//         parentContainer.find("span.money").remove();
//         parentContainer.find("#whatsapp").css("display", "block");
//       // parentContainer.find(".t4s-product-qs__price .t4s-product-price").append(priceRequestLink);
//         parentContainer.find(".price_onrequest").css("display", "block");
//     } else {
//         console.log("kuch price hai")
//         parentContainer.find(".t4s-product-form__buttons").show();
//         parentContainer.find("span.money").show();
//         parentContainer.find("#whatsapp").css("display", "none");
//         parentContainer.find(".price_onrequest").css("display", "none");
//     }
// });
// 	   $( document ).on( "variant:changed", function( evt ) {
// 	     // console.log( evt.currentVariant );
// 	     // $('[data-variant-toggle]').hide(0);
// 	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
// 	   });
// });

jQuery_T4NT(document).ready(function($) {
    function handleVariantChange(variant) {
        var price = variant.price;
        var parentContainer = $(".t4s-product__info-container, .t4s-product-qs-inner");
        var priceRequestLink = `<span><a href="https://api.whatsapp.com/send?phone=923006225159&text=Hello i am interested in {{shop.domain}}{{ product.url }}" class="t4s-pr-item-btn t4s-pr-addtocart callforpricing" rel="nofollow" target="_blank"><span class="t4s-text-pr">Price on Request</span></a></span>`;
        
        if (parseFloat(price) === 0) {
            console.log("Price is zero");
            parentContainer.find(".t4s-product-form__buttons").hide();
            parentContainer.find("span.money").remove();
            parentContainer.find("#whatsapp").css("display", "block");
            parentContainer.find(".price_onrequest").css("display", "block");
        } else {
            console.log("Price is greater than zero");
            parentContainer.find(".t4s-product-form__buttons").show();
            parentContainer.find("span.money").show();
            parentContainer.find("#whatsapp").css("display", "none");
            parentContainer.find(".price_onrequest").css("display", "none");
        }
    }

    // Check on document ready
    var initialVariant = Shopify?.currentVariant; // Assuming the current variant is available globally
    if (initialVariant) {
        handleVariantChange(initialVariant);
    }

    // Handle variant changes dynamically
    $(document).on("variant:changed", function(evt) {
        handleVariantChange(evt.currentVariant);
    });
});





